import { css } from 'lit';
import componentStyles from '../../styles/component.styles.js';
export default css `
    ${componentStyles}
    :host {
        font-family: var(--sgdf-font-sans);
    }

    .team-form {
        padding: var(--sgdf-spacing-small);
    }

    .team-form-content {
        display: grid;
        align-items: center;
        grid-row-gap: var(--sgdf-spacing-small);
        grid-column-gap: var(--sgdf-spacing-small);
    }

    @media screen and (max-width: 500px) {
        .team-form-content {
            grid-template-columns: 1fr 1fr;
            grid-template-rows: auto;
            grid-template-areas:
                'label-team-name label-team-name'
                'team-name team-name'
                'label-team-members label-team-members'
                'team-members team-members'
                'label-team-color label-team-color'
                'team-color team-color'
                'submit delete';
        }
    }

    @media screen and (min-width: 500px) {
        .label {
            display: flex;
            flex-direction: row-reverse;
        }
        .team-form-content {
            grid-template-columns: 1fr 1fr 1fr 1fr;
            grid-template-rows: auto;
            grid-template-areas:
                'label-team-name team-name team-name team-name'
                'label-team-members team-members team-members team-members'
                'label-team-color team-color team-color team-color'
                'submit . . delete';
        }
    }

    .label {
        font-weight: 500;
    }

    .label-team-name {
        grid-area: label-team-name;
    }

    .team-name {
        grid-area: team-name;
    }

    .label-team-members {
        grid-area: label-team-members;
    }

    .team-members {
        grid-area: team-members;
    }

    .label-team-color {
        grid-area: label-team-color;
    }

    .team-color {
        grid-area: team-color;
    }

    .submit {
        grid-area: submit;
    }

    .delete {
        grid-area: delete;
        display: flex;
        flex-direction: row-reverse;
    }
`;
//# sourceMappingURL=team-form.styles.js.map